import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import AppLayout from "@/components/AppLayout";
import Disclaimer from "@/components/Disclaimer";
import { ArrowLeft, Loader2 } from "lucide-react";

export default function ContentDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [item, setItem] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/content/${id}`)
      .then((r) => setItem(r.data))
      .catch((e) => { if (e.response?.status === 403) navigate("/membership"); })
      .finally(() => setLoading(false));
  }, [id, navigate]);

  if (loading) return <AppLayout><div className="flex justify-center py-20"><Loader2 className="h-8 w-8 animate-spin text-wine" /></div></AppLayout>;
  if (!item) return <AppLayout><p>Not found.</p></AppLayout>;

  return (
    <AppLayout>
      <article className="max-w-3xl mx-auto">
        <button data-testid="content-back" onClick={() => navigate("/library")} className="inline-flex items-center gap-2 text-sm text-[#6E5862] hover:text-wine transition-colors mb-6">
          <ArrowLeft className="h-4 w-4" /> Back to library
        </button>
        <span className="inline-flex items-center rounded-full bg-[#F7E9EF] px-3 py-1 text-xs font-medium text-wine capitalize">{item.category === "glp1" ? "GLP-1" : item.category}</span>
        <h1 className="mt-4 font-serif text-4xl sm:text-5xl tracking-tight text-wine leading-tight">{item.title}</h1>

        {item.type === "video" && item.video_url ? (
          <div className="mt-8 aspect-video rounded-3xl overflow-hidden border border-taupe">
            <iframe data-testid="content-video" src={item.video_url} title={item.title} className="w-full h-full" allowFullScreen />
          </div>
        ) : (
          <img src={item.image_url} alt={item.title} className="mt-8 w-full h-72 object-cover rounded-3xl border border-taupe" />
        )}

        <div data-testid="content-body" className="mt-8 space-y-5">
          {item.body.split("\n\n").map((p, i) => (
            <p key={i} className="text-lg text-[#6E5862] leading-relaxed">{p}</p>
          ))}
        </div>

        <Disclaimer className="mt-10 border-t border-taupe pt-6" />
      </article>
    </AppLayout>
  );
}
